import {
  Component, Prop, Vue,
} from 'vue-property-decorator';

@Component
export default class StorageMixin extends Vue {
  @Prop({
    type: String,
    required: false,
  }) readonly localStoragePrefix!: string

  getFromStorage(fieldName: string): string {
    return localStorage.getItem(`${this.localStoragePrefix}-${fieldName}`) || '';
  }

  setToStorage(fieldName: string, value: any) {
    if (fieldName === '' || typeof fieldName === 'undefined' || fieldName === null) {
      return;
    }
    if (typeof value === 'undefined' || value === null) {
      value = '';
    }
    localStorage.setItem(`${this.localStoragePrefix}-${fieldName}`, value);
  }
}
